/**
 * The words on My care (H55), the source both apps copy character for
 * character (`CareCopy` in iOS and Android).
 *
 * The tab is named for what it holds across every kind of content a clinic may
 * prepare for somebody, not for the one kind it holds today, so these sentences
 * never say "meal plan" except where they name that section. A second kind of
 * content adds a section heading here, not a new tab.
 */
export const CARE_COPY = {
  /** The navigation label, on every platform. */
  tab: "My care",
  title: "Your care",
  subtitle: "What your clinics prepared for you.",
  emptyTitle: "Nothing here yet.",
  emptyDetail:
    "When a clinic prepares something for you, like a meal plan, it appears here.",
  /** The one section today (H53). */
  mealPlans: "Meal plans",
  /** The way back from a single item. */
  back: "← Your care",
} as const;
